import React from 'react';
import ReactDOM from 'react-dom';
import NextApp from './NextApp';
import registerServiceWorker from './registerServiceWorker';
// Add this import:
import { getUserProfile } from '@api';
import { openNotification, getAccessToken } from '@common/helpers';
import { AppContainer } from 'react-hot-loader';
import { authenticationInit, getLoginUserInfo } from './common/auth';
import configureStore from './common/appRedux/store';
import { loadCurrentUserInfo, loadUserProfileDetail,
  selectBU, selectCostCenter, selectMultiCostCenter } from './common/appRedux/actions';

import { logOut } from '@common/auth';

const store = configureStore({
  user: getLoginUserInfo()
});

// Wrap the rendering in a function:
const render = Component => {
  store.dispatch(loadCurrentUserInfo());
  ReactDOM.render(
    <AppContainer>
      <Component store={store} />
    </AppContainer>,
    document.getElementById('root')
  );
};

// Webpack Hot Module Replacement API
if (module.hot) {
  module.hot.accept('./NextApp', () => {
    render(NextApp);
  });
}

const main = () => {
  // Do this once
  registerServiceWorker();

  // Render once
  render(NextApp);
};

authenticationInit().subscribe(
  // initial behavior
  () => {
    if(getAccessToken()) {
      localStorage.removeItem('businessUnitList');
      localStorage.removeItem('businessUnit');
      localStorage.removeItem('costCenterId');
      localStorage.removeItem('companyId');
      getUserProfile().subscribe((res) => {
        if(res.id == null)
        {
          logOut();
        }

        const defaultCCs = res.businessUnits?.filter((item) => item.isDefaultBu)?.map((item) => item.costCenterId);
        const selectedCC = defaultCCs?.length > 0 ?
          defaultCCs[0] :
          res.costCenter[0].id;
        const selectBUInit = res.businessUnits?.find((item) => item.isDefaultBu)?.id ||
          res.businessUnits?.filter((item) => item.costCenterId === selectedCC)[0].id;
        localStorage.setItem("businessUnitList", JSON.stringify(res.businessUnits));
        localStorage.setItem("businessUnit", res?.companyOwner ? [] : selectBUInit);
        localStorage.setItem("costCenterId", res.costCenter[0].id);
        localStorage.setItem("companyId", res.company.id);

        store.dispatch(loadUserProfileDetail(res));
        store.dispatch(selectBU(res?.companyOwner ? [] : [selectBUInit]));
        store.dispatch(selectCostCenter(selectedCC));
        store.dispatch(selectMultiCostCenter([]));
        main();
      });}
  },
  // handle initial login error
  (err) => {
    console.error(err);
  },
);

